module.exports = __webpack_public_path__ + "static/media/doorhanRails.c31e66ed.jpg";